import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/EFInformation';
import renewalService from '../../../../../services/Internal/Renewal/EF/efRenewal.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import { Form, Schema } from 'rsuite';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import SupervisingProfessional from '../../../../Shared/Card/SupervisingProfessional';
import Swal from 'sweetalert2';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import SupervisingProfessionalWithAttestation from '../../../../Shared/Card/SupervisingProfessionalWithAttestation';

function SupervisingProfessionalPage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 5;
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineering Firm Renewal",
            isIndividual: false,
            entityId: 0,
            applicationDate: "",
            currentSection: "Supervising Professional"
        }
    );
    const { StringType, BooleanType } = Schema.Types;
    const currentVersion = sectionData.hasFirmSubmittedSupervisingProfessional != null ? 1 : 2;//if there is a value to this radio button, we are in version one and dont show attestations.
    const model = Schema.Model({
        hasFirmSubmittedSupervisingProfessional: BooleanType().when((schema) => {
            return currentVersion == 1 ? BooleanType().isRequired('This field is required.') : BooleanType();
        }),
        electronicSignature: StringType().isRequired('This field is required.')
    });
    useEffect(() => {
        setHasLoaded(false);
        renewalService.efGetSection(store.currentApplicationId, sectionId).then((response) => {
            setSectionData(response.data);
            setIsComplete(response.data.staffReviewComplete)
            renewalService.getFirmRenewal(store.currentApplicationId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            });
        })


    }, [])
    const store = useSelector(x => x);

    const push = useNavigate();

    const handleSubmit = (val, event) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else if (val) {
            renewalService.efPostSection(store.currentApplicationId, sectionId, sectionData.electronicSignature).then((response) => {
                if (response.data) {
                    if (currentVersion == 1) {
                        renewalService.efPostSectionHasFirmSubmittedSupervisingProfessional(store.currentApplicationId, sectionId, sectionData.hasFirmSubmittedSupervisingProfessional).then((data) => {
                            if (data.data) {
                                renewalService.efMarkSectionComplete(store.currentApplicationId, sectionId, isComplete).then((markSectionResponse) => {
                                    if (markSectionResponse.data)
                                        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
                                    else
                                        Swal.fire("Failed to mark section complete");
                                });
                            }
                            else
                                Swal.fire("Failed to post supervising professional section");
                        })
                    }
                    else {
                        renewalService.efMarkSectionComplete(store.currentApplicationId, sectionId, isComplete).then((markSectionResponse) => {
                            if (markSectionResponse.data)
                                push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
                            else
                                Swal.fire("Failed to mark section complete");
                        });
                    }
                }
            })
        }
    }
    return (
        <div>
            <Container fluid>
                <Form model={model} onSubmit={handleSubmit} onChange={setSectionData} fluid formValue={sectionData}>
                    <FormEntityInformation {...entityInfo} />
                    <Row className="mb-3">
                        <Col> <Information content={GetRenewalInformationContent("supervisingProfessional")} /></Col>
                    </Row>
                    {hasLoaded ?
                        <>
                            <Row className="mb-3">
                                <Col>
                                    {currentVersion == 1 ?
                                        <SupervisingProfessional
                                            isReadOnly={!isUserEditable}
                                            isRenewal={true}
                                            isInternal={true}
                                            entityId={entityInfo.entityId}
                                            prefix={"EF"}
                                            sectionId={sectionId}
                                            sectionDataId={sectionData.id}
                                            parentTypeId={3}
                                            firmName={entityInfo.entityName}
                                            firmCredential={entityInfo.licenseNumber}
                                            parentId={store.currentApplicationId}
                                        /> :
                                        <SupervisingProfessionalWithAttestation
                                            isReadOnly={!isUserEditable}
                                            isRenewal={true}
                                            isInternal={true}
                                            entityId={entityInfo.entityId}
                                            prefix={"EF"}
                                            sectionId={sectionId}
                                            sectionDataId={sectionData.id}
                                            parentTypeId={3}
                                            firmName={entityInfo.entityName}
                                            firmCredential={entityInfo.licenseNumber}
                                            parentId={store.currentApplicationId}
                                        />
                                    }
                                </Col>
                            </Row>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete}
                                showSectionComplete={true}
                                backToSectionLink="/internal/efrenewal/sections" />
                        </> : <LoadingSpinner />
                    }
                </Form>
            </Container>
        </div>
    );
}
export default SupervisingProfessionalPage